import type { SearchSearch } from '../model/filters';
import { useHyperguestSearch } from '@hyperguest/entities/hyperguest';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { HotelSearchForm } from './hotel-search-form';
import css from './hyperguest-search.module.scss';
import { ResultsGrid } from './results-grid';

export const HyperguestSearch = () => {
  const search = useSearch({ strict: false }) as SearchSearch;
  const navigate = useNavigate();

  // Search only fires once the URL has all four required params.
  const input =
    search.hotelIds && search.checkIn && search.nights && search.guests
      ? {
          hotelIds: search.hotelIds,
          checkIn: search.checkIn,
          nights: search.nights,
          guests: search.guests,
        }
      : null;
  const query = useHyperguestSearch(input);

  return (
    <div className={css.root}>
      <HotelSearchForm
        initial={{
          checkIn: search.checkIn,
          nights: search.nights,
          guests: search.guests,
          hotelIds: search.hotelIds,
        }}
        onSubmit={(values) => {
          const reducer = (): SearchSearch => values;
          navigate({
            // biome-ignore lint/suspicious/noExplicitAny: cross-domain route reference
            to: '/management/hyperguest/search' as any,
            // biome-ignore lint/suspicious/noExplicitAny: cross-route search reducer
            search: reducer as unknown as any,
            replace: true,
          });
        }}
      />
      <ResultsGrid
        results={query.data?.results}
        loading={query.isFetching}
        error={query.error ? query.error.message : null}
      />
    </div>
  );
};
